"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var deserializeParagraph = function deserializeParagraph(options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    p = _setDefaults.p;
  return {
    element: (0, _slatePlugins.getElementDeserializer)({
      type: p.type,
      rules: [{
        nodeNames: 'P'
      }]
    })
  };
};
var _default = exports["default"] = deserializeParagraph;